module.exports = __webpack_public_path__ + "media/images/council-sidebar-d98f291c51c22280f133cdc8fb813061.png";